export default __webpack_public_path__ + "9684b0eb58c6b91f26db5abdd3cb4b2f.svg";